import { useState } from 'react'

const addDays = (iso: string, days: number) => {
  const d = new Date(`${iso}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}

const fmt = (iso: string, options: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat('ru-RU', { ...options, timeZone: 'UTC' }).format(
    new Date(`${iso}T12:00:00Z`),
  )

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

/**
 * Неделя пн–вс со стрелками. Даты — строки YYYY-MM-DD в поясе локации, поэтому
 * вся арифметика в UTC: так день не съезжает от часового пояса браузера.
 */
export function DayStrip({
  today,
  value,
  onChange,
  maxWeeks = 8,
}: {
  today: string
  value: string
  onChange: (iso: string) => void
  maxWeeks?: number
}) {
  const monday = addDays(today, -((new Date(`${today}T00:00:00Z`).getUTCDay() + 6) % 7))
  const [week, setWeek] = useState(0)
  const days = Array.from({ length: 7 }, (_, n) => addDays(monday, week * 7 + n))

  return (
    <section className="section">
      <div className="section__head">
        <h2>Выберите дату</h2>
        <div className="week-nav">
          <span>{capitalize(fmt(days[3], { month: 'long', year: 'numeric' }).replace(' г.', ''))}</span>
          <button
            type="button"
            className="icon-btn"
            aria-label="Предыдущая неделя"
            disabled={week === 0}
            onClick={() => setWeek(week - 1)}
          >
            ‹
          </button>
          <button
            type="button"
            className="icon-btn"
            aria-label="Следующая неделя"
            disabled={week >= maxWeeks - 1}
            onClick={() => setWeek(week + 1)}
          >
            ›
          </button>
        </div>
      </div>
      <div className="days" role="group" aria-label="День">
        {days.map((d) => (
          <button
            key={d}
            type="button"
            className="chip day"
            aria-pressed={d === value}
            disabled={d < today}
            onClick={() => onChange(d)}
          >
            <small>{capitalize(fmt(d, { weekday: 'short' }))}</small>
            {Number(d.slice(8))}
          </button>
        ))}
      </div>
    </section>
  )
}
